import { useState, useEffect, useRef } from "react";
import { stream_data } from "../config/stream_data";
import Select from "react-select";
import { ChevronDown } from "lucide-react";
import { ChevronUp } from "lucide-react";
import { Button, Form } from "react-bootstrap";
import { Check } from "lucide-react";
import "../style/percentage-filter.css"

const yearOptions = [
  { value: 1, label: "1st Year" },
  { value: 2, label: "2nd Year" },
  { value: 3, label: "3rd Year" },
  { value: 4, label: "4th Year" }
];

const conditionOptions = [
  { value: ">", label: "Greater than (>)" },
  { value: "<", label: "Less than (<)" },
  { value: ">=", label: "Greater than or equal (>=)" },
  { value: "<=", label: "Less than or equal (<=)" },
  { value: "=", label: "Equal to (=)" },
  { value: "!=", label: "Not equal to (!=)" }
];

export default function PercentageFilter({ onFiltersChange, degreeArr=[], handleApply}) {
  const normalizedDegreeArr = (degreeArr || [])?.map(d => ({
    value: d.value,
    label: d.label,
    __isNew__: d.__isNew__ || false
  }));

  const [open, setOpen] = useState(false);
  const hasPrefilledRef = useRef(false);
  const [filters, setFilters] = useState([
    { degree: null, year: "", condition: "", value: "", marks_type: "" }
  ]);

  const buildPayload = (filters) =>
    filters
      .filter(f => f.degree !== null &&  f.condition && f.value !== "")
      .map((f) => ({
        degree_title: f.degree,
        studying_year:
          f.marks_type === "cgpa"
            ? yearOptions.find(y => y.value === f.year)?.label || null
            : null,
        marks_type: f.marks_type,
        condition: f.condition,
        value: Number(f.value)
    }));

  useEffect(() => {
    if (hasPrefilledRef.current) return;
    const manualFilters = filters.filter(f => !f.isPrefilled);

    if (!degreeArr?.length) {
      if (filters.some(f => f.isPrefilled)) {
        setFilters(manualFilters);
        // onFiltersChange?.(buildPayload(manualFilters));
      }
      return;
    }

    const validDegrees = degreeArr.filter(d => d?.value);

    const prefilledFilters = validDegrees.map(d => ({
      degree: d.value,
      year: "",
      condition: "",
      value: "",
      marks_type: d.value === 10 || d.value === 12 ? "percentage" : "cgpa",
      isPrefilled: true
    }));

    const merged = [...prefilledFilters, ...manualFilters];
    setFilters(merged);

    hasPrefilledRef.current = true;
  }, [degreeArr]);


  const degreeTitle = Array.from(
    new Set(
      stream_data.streams.flatMap((s) =>
        s.degrees.map((d) => d.name)
      )
    )
  ).map((name) => ({ value: name, label: name }));

  const allDegree = [
    { value: null, label: "Select Degree" },
    { value: 10, label: "10th" },
    { value: 12, label: "12th" },
    ...degreeTitle,
    ...normalizedDegreeArr.filter(fl=>!degreeTitle.some(found=>found.value === fl.value))
  ];

  const updateFilter = (index, key, value) => {
    setFilters((prev) => {
      const updated = [...prev];
      updated[index][key] = value;
      if (key === "degree" || key === "year") {
        const yearDisabled =
          updated[index].degree === 10 ||
          updated[index].degree === 12 ||
          updated[index].degree === null;

        updated[index].marks_type = yearDisabled ? "percentage" : "cgpa";
      }

      return updated;
    });
  };

  const addFilter = () => {
    const updated = [
      ...filters,
      { degree: null, year: "", condition: "", value: "", marks_type: ""}
    ];
    setFilters(updated);
  };

  const removeFilter = (index) => {
    const updated = filters.filter((_, i) => i !== index);
    setFilters(updated);
  };

  const applyFilters = () => {
    onFiltersChange?.(buildPayload(filters));
    handleApply?.(buildPayload(filters))
    setOpen(false);
  };

  useEffect(()=>{
    if(filters?.length===0){
      handleApply?.(buildPayload(filters))
      onFiltersChange?.(buildPayload(filters));
      setTimeout(()=>{
        setOpen(false)
      },2000)
    }
    if(open && filters?.length===0){
      setFilters([{ degree: null, year: "", condition: "", value: "", marks_type: "" }]) 
    }
    
  },[filters,open])


  return (
    <>
      <Button
        className={`apply-btn d-flex gap-2 text-light mb-2`}
        onClick={() => setOpen(p => !p)}
        size="lg"
        variant="primary"
      >
        <span className="">Filter by Student Marks</span>
        {open ? <ChevronUp size={20}/>:<ChevronDown size={20}/>}
      </Button>

      <div className={`percentage-filter-wrapper mb-4 ${open ? "border rounded-1":""}`}>
        <div className={`filter-body ${open ? 'open' : ''}`}>
          <div className="filter-body-content">
            {filters?.length!=0 &&
            <div className="filter-labels">
              <div style={{ flex: '0 0 22%' }}><Form.Label className="fw-bold small mb-1">Degree</Form.Label></div>
              <div style={{ flex: '0 0 18%' }}><Form.Label className="fw-bold small mb-1">Studying Year</Form.Label></div>
              <div style={{ flex: '0 0 20%' }}><Form.Label className="fw-bold small mb-1">Condition(Percentage/CGPA)</Form.Label></div>
              <div style={{ flex: '0 0 20%' }}><Form.Label className="fw-bold small mb-1">Value</Form.Label></div>
              <div style={{ flex: '0 0 18%' }}></div>
            </div>}
            {filters?.length!=0 &&
            <div className="filters-list">
              {filters.map((f, index) => {
                const yearDisabled = f.degree === 10 ||  f.degree=== "10th" || f.degree==="12th"|| f.degree === 12 || f.degree === null;

                return (
                  <div key={index} className="filter-row">
                    <div className="filter-field">
                      <label className="field-label mobile-only">Degree</label>
                      <Select
                        value={allDegree.find(d => d.value === f.degree)}
                        options={allDegree}
                        onChange={(s) =>
                          updateFilter(index, "degree", s.value)
                        }
                        placeholder="Degree"
                        menuPosition="fixed"
                        menuPortalTarget={document.body}
                        isSearchable
                        isDisabled={f.isPrefilled} 
                        components={{ IndicatorSeparator: () => null }}
                      />
                    </div>

                    <div className="filter-field">
                      <label className="field-label mobile-only">Studying Year</label>
                      {yearDisabled ? (
                        <div className="disabled-field">N/A</div>
                      ) : (
                        <Select
                          value={yearOptions.find(d => d.value === f.year)}
                          options={yearOptions}
                          onChange={(s) =>
                            updateFilter(index, "year", s.value)
                          }
                          placeholder="Year"
                          menuPosition="fixed"
                          menuPortalTarget={document.body}
                          components={{ IndicatorSeparator: () => null }}
                        />
                      )}
                    </div>

                    <div className="filter-field">
                      <label className="field-label mobile-only">Condition</label>
                      <Select
                        value={conditionOptions.find(d => d.value === f.condition)}
                        options={conditionOptions}
                        onChange={(s) => updateFilter(index, "condition", s.value)}
                        placeholder="Condition"
                        menuPosition="fixed"
                        menuPortalTarget={document.body}
                        components={{ IndicatorSeparator: () => null }}
                      />
                    </div>

                    <div className="filter-field">
                      <label className="field-label mobile-only">
                        {yearDisabled ? "Percentage" : "CGPA"}
                      </label>
                      <input
                        className="custom-input"
                        placeholder={yearDisabled ? "e.g., 85" : "e.g., 8.5"}
                        value={f.value}
                        type="number"
                        step={yearDisabled ? 1 : 0.1}
                        min={0}
                        max={yearDisabled ? 100 : 10}
                        onChange={(e) => {
                          let val = e.target.value;

                          if (val === "") {
                            updateFilter(index, "value", "");
                            return;
                          }

                          val = Number(val);

                          if (yearDisabled) {
                            val = Math.min(100, Math.max(0, val));
                          } else {
                            val = Math.min(10, Math.max(0, val));
                          }

                          updateFilter(index, "value", val);
                        }}
                      />

                      {/* <input
                        className="custom-input"
                        placeholder={yearDisabled ? "e.g., 85" : "e.g., 8.5"}
                        value={f.value}
                        onChange={(e) => updateFilter(index, "value", e.target.value)}
                        step="any"
                        type="number"
                        min={0}
                        max={yearDisabled ? 100 : 10}
                      /> */}
                    </div>

                    <div className="filter-actions">
                      {index === filters.length - 1 && (
                        <Button
                          size="sm"
                          variant="outline-primary"
                          className="w-100"
                          onClick={addFilter}
                        >
                          Add
                        </Button>
                      )}
                      {/* {(!f?.isPrefilled) && ( */}
                        <Button
                          size="sm"
                          variant="outline-danger"
                          className="w-100"
                          onClick={() => removeFilter(index)}
                        >
                          Remove
                        </Button>
                      {/* )} */}
                    </div>
                  </div>
                );
              })}
            </div>}
            <div className="filter-footer">
            {/* {filters?.length!=0 ? */}
              <button
                className="apply-btn"
                onClick={applyFilters}
              >
                <Check size={20} />
                Apply Filters
              </button>
            {/* :
             <Button
               size="sm"
               variant="outline-primary"
               className="apply-btn"
               onClick={addFilter}
             >
               Add Marks
             </Button>
             } */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}